import React, { useState } from 'react';
import { Box } from '@sparknz/spark-pattern-library';

import EligibilityLineSelectorProductDetails from '../EligibilityLineSelectorProductDetails';
import { ExistingPlans, IfpExistingPlanSelectorButton } from './components';

const IfpExistingPlanSelector = () => {
  const [selectedLineNumber, setSelectedLineNumber] = useState<string | null>();

  return (
    <Box pt="s5">
      <EligibilityLineSelectorProductDetails />
      <ExistingPlans
        selectedLineNumber={selectedLineNumber}
        setSelectedLineNumber={setSelectedLineNumber}
      />
      <IfpExistingPlanSelectorButton selectedLineNumber={selectedLineNumber} />
    </Box>
  );
};

export default IfpExistingPlanSelector;
